module.exports = "<div class=\"monitoring-issues-list\">\n\n\t<jf-grid\n\t\t\tgrid-options=\"SystemMonitoring.gridOptions\"\n\t\t\tfilter-field=\"id\"\n\t\t\tobject-name=\"problem\"\n\t\t\tauto-focus=\"true\">\n\t</jf-grid>\n\n\t<style>\n\t\t.status{color:darkred}\n\n\t\t.status.online{color:#43a047}\n\t</style>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./modules/xray/states/settings/tabs/system_monitoring/system_monitoring.html
// module id = 705
// module chunks = 6